// src/store/modules/notificationPreferences.js
import api from "@/config/api";
import { handleApiError } from "@/utils/ErrorHandler";

export default {
  state: {
    preferences: [],
    savePreferencesResponse: null,
    loadingPreferences: false,
  },

  mutations: {
    setPreferences(state, payload) {
      state.preferences = payload;
    },
    setSavePreferencesResponse(state, payload) {
      state.savePreferencesResponse = payload;
    },
    setLoadingPreferences(state, payload) {
      state.loadingPreferences = payload;
    },
  },

  actions: {
    // 1. Fetch notification preferences
    async fetchNotificationPreferences({ commit }, { personId, locationId }) {
      commit("setLoadingPreferences", true);
      try {
        const response = await api.get(
          `/users/${personId}/notification-preferences/${locationId}`
        );
        const prefs = response.data?.data || response.data;
        commit("setPreferences", prefs);
        return prefs;
      } catch (error) {
        handleApiError(error, "Failed to fetch notification preferences");
        throw error;
      } finally {
        commit("setLoadingPreferences", false);
      }
    },

    // 2. Save notification preferences
    async saveNotificationPreferences(
      { commit },
      { personId, locationId, ruleNumber, notificationRule }
    ) {
      try {
        const response = await api.post("/manageuserajax", {
          cmd: "savenotify",
          personid: personId,
          locationid: locationId,
          rulenumber: ruleNumber,
          notification_rule: notificationRule, // <-- fixed here
        });

        commit("setSavePreferencesResponse", response.data);
        return response.data;
      } catch (error) {
        handleApiError(error, "Failed to save notification preferences");
        throw error;
      }
    },
  },

  getters: {
    getNotificationPreferences: (state) => state.preferences,
    getSavePreferencesResponse: (state) => state.savePreferencesResponse,
    isNotificationPreferencesLoading: (state) => state.loadingPreferences,
  },
};
